import {
  ArrowUpRightIcon,
  FileTextIcon,
  GlobeHemisphereWestIcon,
  UsersThreeIcon,
} from "@phosphor-icons/react";
import { useEffect, useState } from "react";

import { apiRequest } from "../api/client";
import { LoadingState } from "../components/LoadingState";
import { PageHeader } from "../components/PageHeader";
import { Link } from "../router";
import type { AdminUser, Locale, Page } from "../types";

type DashboardData = {
  pages: Page[];
  locales: Locale[];
  users: AdminUser[];
};

export function DashboardPage() {
  const [data, setData] = useState<DashboardData | null>(null);
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([
      apiRequest<Page[]>("/api/v1/admin/pages"),
      apiRequest<Locale[]>("/api/v1/admin/locales"),
      apiRequest<AdminUser[]>("/api/v1/admin/users"),
    ])
      .then(([pages, locales, users]) => setData({ pages, locales, users }))
      .catch(() => setError("Не удалось загрузить состояние Command Center"));
  }, []);

  return (
    <div className="page">
      <PageHeader
        description="Текущее состояние контента, языков и команды сайта."
        eyebrow="Рабочее пространство"
        title="Обзор"
      />

      {error && <div className="notice notice--error">{error}</div>}
      {!data ? (
        <LoadingState rows={4} />
      ) : (
        <>
          <section className="metrics-strip" aria-label="Основные показатели">
            <div>
              <span>Страницы</span>
              <strong>{data.pages.length}</strong>
              <FileTextIcon size={21} />
            </div>
            <div>
              <span>Активные языки</span>
              <strong>
                {data.locales.filter((locale) => locale.is_active).length}
              </strong>
              <GlobeHemisphereWestIcon size={21} />
            </div>
            <div>
              <span>Члены команды</span>
              <strong>
                {data.users.filter((user) => user.is_active).length}
              </strong>
              <UsersThreeIcon size={21} />
            </div>
          </section>

          <section className="dashboard-grid">
            <div className="section-block">
              <div className="section-heading">
                <div>
                  <span className="eyebrow">Контент</span>
                  <h2>Последние страницы</h2>
                </div>
                <Link className="text-link" to="/pages">
                  Все страницы <ArrowUpRightIcon size={16} />
                </Link>
              </div>
              <div className="simple-list">
                {data.pages.slice(0, 6).map((page) => (
                  <Link key={page.id} to={`/pages/${page.id}`}>
                    <span>
                      <strong>{page.internal_name}</strong>
                      <small>{page.page_key}</small>
                    </span>
                    <span className="mono">{page.template_key}</span>
                  </Link>
                ))}
              </div>
            </div>

            <aside className="system-rail">
              <span className="eyebrow">Система</span>
              <h2>Контур готов к редактированию</h2>
              <p>
                Публикации проходят через версионный API и адресно обновляют кеш
                Next.js.
              </p>
              <div className="system-status">
                <span>
                  <i /> PostgreSQL
                </span>
                <strong>online</strong>
              </div>
              <div className="system-status">
                <span>
                  <i /> Publication outbox
                </span>
                <strong>ready</strong>
              </div>
              <div className="system-status">
                <span>
                  <i /> WebP pipeline
                </span>
                <strong>strict</strong>
              </div>
            </aside>
          </section>
        </>
      )}
    </div>
  );
}
